import { render, staticRenderFns } from "./ButtonToolbar.vue?vue&type=template&id=31286c18&"
import script from "./ButtonToolbar.vue?vue&type=script&lang=js&"
export * from "./ButtonToolbar.vue?vue&type=script&lang=js&"
import style0 from "./ButtonToolbar.vue?vue&type=style&index=0&id=31286c18&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports